var _path, _path2, _g, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43283 18.3332H5.36116C3.32449 18.3332 1.66699 16.6757 1.66699 14.6373V5.36317C1.66699 3.32484 3.32449 1.6665 5.36116 1.6665H9.42366C11.462 1.6665 13.1203 3.32484 13.1203 5.36317V6.13984C13.1203 6.48484 12.8403 6.76484 12.4953 6.76484C12.1503 6.76484 11.8703 6.48484 11.8703 6.13984V5.36317C11.8703 4.01317 10.7728 2.9165 9.42366 2.9165H5.36116C4.01366 2.9165 2.91699 4.01317 2.91699 5.36317V14.6373C2.91699 15.9865 4.01366 17.0832 5.36116 17.0832H9.43283C10.7762 17.0832 11.8703 15.9898 11.8703 14.6465V13.8607C11.8703 13.5157 12.1503 13.2357 12.4953 13.2357C12.8403 13.2357 13.1203 13.5157 13.1203 13.8607V14.6465C13.1203 16.6798 11.4653 18.3332 9.43283 18.3332Z",
    fill: "#EFF8FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_4169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 12,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49683 9.375H18.7809V10.625H7.49683V9.375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_4169)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.156 10.625H8.12183C7.77683 10.625 7.49683 10.345 7.49683 10C7.49683 9.655 7.77683 9.375 8.12183 9.375H18.156C18.501 9.375 18.781 9.655 18.781 10C18.781 10.345 18.501 10.625 18.156 10.625Z",
    fill: "#EFF8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_443_4169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 6,
    width: 4,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0916 6.9458H18.781V13.0548H15.0916V6.9458Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_443_4169)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7163 13.0548C15.5563 13.0548 15.3955 12.9939 15.2738 12.8706C15.0305 12.6256 15.0313 12.2306 15.2755 11.9873L17.2705 9.99976L15.2755 8.01309C15.0313 7.76976 15.0297 7.37476 15.2738 7.12976C15.5172 6.88476 15.9122 6.88476 16.1572 7.12809L18.5972 9.55726C18.7155 9.67393 18.7813 9.83393 18.7813 9.99976C18.7813 10.1656 18.7155 10.3256 18.5972 10.4423L16.1572 12.8723C16.0355 12.9939 15.8755 13.0548 15.7163 13.0548Z",
    fill: "#EFF8FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5e197251.svg";
export { ForwardRef as ReactComponent };